import { IPaginatedResponse, IResponse, ISearchRequest } from "..";
import client from "../client";

export interface IEventResponse {
  id: string;
  name: string;

  createdAt: Date;

  result: any;
  success: boolean;

  headers: any;
  metaDate: any;
}

async function getEvents() {
  return client.get<IResponse<IEventResponse[]>>(`/event`);
}

async function createEvent(event: IEventResponse) {
  return client.post<IResponse<IEventResponse[]>>(`/event`, event);
}

async function searchEvents(req: ISearchRequest) {
  return client.post<IPaginatedResponse<IEventResponse[]>>(
    "/event/search",
    req
  );
}

const api = {
  getEvents,
  createEvent,
  searchEvents,
};

export default api;
